import { collection, addDoc, query, where, orderBy, limit, getDocs, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

// Journal d'activité (append-only). Le contexte utilisateur est fixé une fois par session.
let context = { cabinetId: null, userUid: null, userName: '', role: '' };

export const AUDIT_ACTIONS = {
  LOGIN: 'connexion',
  PROJECT_CREATE: 'dossier.creation',
  PROJECT_UPDATE: 'dossier.modification',
  PROJECT_DELETE: 'dossier.suppression',
  PROJECT_STATUS: 'dossier.statut',
  AVANCE_ADD: 'avance.ajout',
  AVANCE_DELETE: 'avance.suppression',
  DEPENSE_CREATE: 'depense.creation',
  DEPENSE_UPDATE: 'depense.modification',
  DEPENSE_DELETE: 'depense.suppression',
  FACTURE_CREATE: 'facture.creation',
  FACTURE_UPDATE: 'facture.modification',
  FACTURE_DELETE: 'facture.suppression',
  CAISSE_RESET: 'caisse.initialisation',
  CLIENT_CREATE: 'client.creation',
  CLIENT_UPDATE: 'client.modification',
  CLIENT_DELETE: 'client.suppression',
  MEMBER_CREATE: 'agent.creation',
  MEMBER_DEACTIVATE: 'agent.desactivation',
  MEMBER_REACTIVATE: 'agent.reactivation',
  MEMBER_ROLE: 'agent.role',
  NOTE_ADD: 'note.ajout',
  PROFILE_UPDATE: 'profil.modification'
};

export const AUDIT_LABELS = {
  'connexion': 'Connexion',
  'dossier.creation': 'Création de dossier',
  'dossier.modification': 'Modification de dossier',
  'dossier.suppression': 'Suppression de dossier',
  'dossier.statut': 'Changement de statut',
  'avance.ajout': 'Avance encaissée',
  'avance.suppression': 'Avance supprimée',
  'depense.creation': 'Dépense ajoutée',
  'depense.modification': 'Dépense modifiée',
  'depense.suppression': 'Dépense supprimée',
  'facture.creation': 'Devis / facture créé',
  'facture.modification': 'Devis / facture modifié',
  'facture.suppression': 'Devis / facture supprimé',
  'caisse.initialisation': 'Caisse initialisée',
  'client.creation': 'Client ajouté',
  'client.modification': 'Client modifié',
  'client.suppression': 'Client supprimé',
  'agent.creation': 'Compte agent créé',
  'agent.desactivation': 'Compte agent désactivé',
  'agent.reactivation': 'Compte agent réactivé',
  'agent.role': 'Rôle modifié',
  'note.ajout': 'Note ajoutée',
  'profil.modification': 'Profil modifié'
};

export class AuditService {
  static setContext(next) {
    context = { ...context, ...next };
  }

  // Écriture silencieuse : ne doit jamais bloquer l'action métier
  static async log(action, { entityType = '', entityId = '', label = '', details = null } = {}) {
    if (!context.cabinetId || !context.userUid) return;
    try {
      await addDoc(collection(db, 'audit_logs'), {
        cabinetId: context.cabinetId,
        userUid: context.userUid,
        userName: context.userName,
        role: context.role,
        action,
        entityType,
        entityId: entityId || '',
        label: label || '',
        details: details || null,
        createdAt: serverTimestamp()
      });
    } catch (error) {
      console.warn('Audit non enregistré:', error.message);
    }
  }

  static async list(cabinetId, { limitCount = 300 } = {}) {
    try {
      const snap = await getDocs(query(
        collection(db, 'audit_logs'), where('cabinetId', '==', cabinetId), orderBy('createdAt', 'desc'), limit(limitCount)
      ));
      const items = [];
      snap.forEach((d) => items.push({ id: d.id, ...d.data() }));
      return { success: true, items };
    } catch (error) {
      console.error('Erreur journal:', error);
      return { success: false, error: error.message, items: [] };
    }
  }
}
